import ShModel from "./sh-model";
import { belongsTo, attr } from '@ember-data/model';

const FACTOID_TYPE = 'company_credit';

export const COMPANY_CREDIT = {
  FACTOID_TYPE,
};

class CompanyCredit extends ShModel {
  @attr('number') amountInCents;
  @attr('number') amountUsedInCents;
  @attr('string') memo;
  @attr('string') integrityChecksum;

  @attr('date') createdAt;
  @attr('date') releasedAt;

  @belongsTo('company', { async: false }) company;
  @belongsTo('costCode', { async: false }) costCode;
  @belongsTo('shGeneralInvoice', { async: false }) shGeneralInvoice;

  get amountInDollars() {
    return (this.amountInCents / 100).toFixed(2);
  }

  get amountRemainingInCents() {
    return this.amountInCents - this.amountUsedInCents;
  }

  get amountRemainingInDollars() {
    return (this.amountRemainingInCents / 100).toFixed(2);
  }

  get amountUsedInDollars() {
    return (this.amountUsedInCents / 100).toFixed(2);
  }

  get isPaid() {
    return !!this.paidAt;
  }

  get isReleased() {
    return !!this.releasedAt;
  }
}

export default CompanyCredit;
